import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, ShieldCheck, ExternalLink } from "lucide-react";
import { Reveal, SplitLines } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { BUSINESS, waLink } from "../data/business";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-36 bg-[#0d0d0d] border-t border-gold/10 grain">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-6">
        <Reveal><p className="eyebrow mb-6">Visit or message</p></Reveal>
        <h2 className="font-display font-light text-ivory text-[clamp(2.4rem,5.5vw,5rem)] leading-[0.95]">
          <SplitLines inView lines={["Abids,", <span key="a" className="text-saffron italic">Hyderabad.</span>]} />
        </h2>
        <Reveal delay={0.2} className="mt-8 text-ivory/60 font-light leading-relaxed max-w-md">
          Come in to try stones on your hand under the lamp, or message us your dream piece or production spec on <WhatsAppIcon size={16} className="text-[#25D366]" /> — photos, a quote and a GST invoice usually within the hour.
        </Reveal>
        <Reveal delay={0.3} className="mt-10 flex flex-wrap gap-4">
          <a href={waLink("Hello Padmavati Gem & Jewelss, I'd like to enquire about lab-grown diamonds.")} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-btn" className="btn-gold"><WhatsAppIcon size={17} /> {BUSINESS.phone}</a>
          <Link to="/enquiry" data-testid="contact-enquiry-page-btn" className="btn-outline">Enquiry form</Link>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="lg:col-span-6 grid sm:grid-cols-2 gap-px bg-gold/15 border border-gold/15" data-testid="contact-details">
        {[
          { Icon: MapPin, k: "Address", v: BUSINESS.addressLines, link: BUSINESS.mapsUrl, testId: "contact-address" },
          { Icon: Phone, k: <>Mobile / <WhatsAppIcon size={13} className="text-[#25D366]" /></>, key: "phone", v: [BUSINESS.phone], link: `tel:+${BUSINESS.whatsapp}`, testId: "contact-phone" },
          { Icon: Clock, k: "Hours", v: [BUSINESS.hours, "Sunday by appointment"], testId: "contact-hours" },
          { Icon: ShieldCheck, k: "Registered business", v: [`GSTIN ${BUSINESS.gst}`, `Shop Reg. ${BUSINESS.shopReg}`, `Proprietor · ${BUSINESS.proprietor}`], testId: "contact-registration" },
        ].map(({ Icon, k, v, link, testId }) => (
          <div key={testId} data-testid={testId} className="bg-[#0d0d0d] p-7 group">
            <Icon size={18} strokeWidth={1.5} className="text-gold mb-5" />
            <p className="eyebrow">{k}</p>
            <div className="mt-3 space-y-1">
              {v.map((line) => <p key={line} className="text-ivory/85 text-sm font-light">{line}</p>)}
            </div>
            {link && <a href={link} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.25em] text-saffron/80 hover:text-saffron">Open <ExternalLink size={11} /></a>}
          </div>
        ))}
      </Reveal>
    </div>
  </section>
);
